// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__21c9f","success":"Toast_success__1RiCm","error":"Toast_error__2p3Ea"};